import { render } from "./DirectMessageModal.vue?vue&type=template&id=6872f11c"
import script from "./DirectMessageModal.vue?vue&type=script&lang=js"
export * from "./DirectMessageModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__